import React from 'react'
import './App.scss'
import { Route, Switch } from 'react-router-dom'
import HomeScreen from './components/HomeScreen/HomeScreen'
import Menu from 'components/Menu/Menu'
import SettingsList from 'components/SettingsList/SettingsList'
import Option from 'components/Option/Option'

function App() {
    return (
        <div className="App">
            <Switch>
                <Route exact path="/">
                    <HomeScreen />
                </Route>
                <Route path="/menu">
                    <Menu />
                </Route>
                <Route path="/settings/:option/:suboption?">
                    <Option />
                </Route>
                <Route path="/settings">
                    <SettingsList />
                </Route>
            </Switch>
        </div>
    )
}

export default App
